import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveHoleRightStraight from "../assets/cave_hole_right_straight.png";

const Room5 = ({ goToRoom11, goToRoom12, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveHoleRightStraight}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "40%", left: "70%", position: "absolute" }}
          onClick={goToRoom11}
        >
          Straight
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "48%", left: "90%", position: "absolute" }}
          onClick={goToRoom12}
        >
          Right
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room5;